<mat-card class="card-size  element" [ngClass]="{'disabled-card':disabled}">
  @if (device!=null) {
    <mat-card-content>
      <div class="text-container">
        <mat-card-title
        style="max-width: calc(100% - 80px);word-break: break-word;">{{device.seriale}}</mat-card-title>
        <div class="button-card-sovrapossition">
          <ng-content select="[button]">
          </ng-content>
        </div>
      </div>
      <div class="flex-start-center w100 flex-direction-row">
        @if (device.lastComm) {
          <div class="flex-start-start flex-direction-column text-container"
            >
            <div class="text-child">{{'IotDevices.lastComm'|translate}}</div>
            <div>{{device.lastComm|customDate:'medium'|async}}</div>
          </div>
        }
        @if (device.type) {
          <div class="flex-start-start flex-direction-column text-container"
            >
            <div class="text-child">{{'IotDevices.type'|translate}}</div>
            <div>{{'IotDevices.typePossibleValues.' + device.type|translate}}</div>
          </div>
        }
        @if (device.vpn_address) {
          <div class="flex-start-start flex-direction-column text-container"
            >
            <div class="text-child">{{'IotDevices.vpn_address'|translate}}</div>
            <div>{{device.vpn_address}}</div>
          </div>
        }
        @if (device.environment) {
          <div class="flex-start-start flex-direction-column text-container"
            >
            <div class="text-child">{{'IotDevices.environment'|translate}}</div>
            <div>{{device.environment}}</div>
          </div>
        }
      </div>
    </mat-card-content>
  }

</mat-card>
